/* Aximyra 영상 carousel — independent of Shopify product-media gallery. */
(function(){
  function initialize(){
    document.querySelectorAll('[data-axm-video-carousel]').forEach(function(root){
      if(root.dataset.axmInitialized==='true')return;
      root.dataset.axmInitialized='true';
      var stage=root.querySelector('[data-axm-video-stage]');
      var cards=Array.from(root.querySelectorAll('[data-axm-card]'));
      var dots=Array.from(root.querySelectorAll('[data-axm-dot]'));
      var videos=cards.map(function(card){return card.querySelector('video[data-axm-howto-video]')});
      if(!stage||cards.length!==3||videos.some(function(v){return !v}))return;
      var active=0,downX=0,downY=0,touching=false,skipClickUntil=0;
      function playVideo(video){
        if(!video||!video.isConnected||document.hidden)return;
        video.muted=true;
        video.defaultMuted=true;
        video.autoplay=true;
        video.loop=true;
        video.playsInline=true;
        var promise=video.play();
        if(promise&&typeof promise.catch==='function')promise.catch(function(){});
      }
      function playAll(){
        videos.forEach(playVideo);
      }
      function show(index){
        active=(index+cards.length)%cards.length;
        cards.forEach(function(card,i){
          var delta=(i-active+cards.length)%cards.length;
          var pos=delta===0?'0':delta===1?'1':'-1';
          card.dataset.position=pos;
          card.setAttribute('aria-label','Aximyra 영상 '+(i+1)+(delta===0?' — 현재 영상':' — 선택'));
          card.setAttribute('role','button');
          card.tabIndex=delta===0?-1:0;
        });
        dots.forEach(function(dot,i){
          var current=i===active;
          dot.classList.toggle('is-current',current);
          dot.setAttribute('aria-pressed',current?'true':'false');
        });
        playAll();
      }
      videos.forEach(function(video){
        video.setAttribute('muted','');
        video.setAttribute('autoplay','');
        video.setAttribute('loop','');
        video.setAttribute('playsinline','');
        video.addEventListener('pause',function(){
          // A separate Shopify gallery or section can pause <video> globally.
          // Aximyra's muted demo is self-managed and resumes independently.
          if(document.hidden||!video.isConnected)return;
          window.requestAnimationFrame(function(){if(video.paused)playVideo(video)});
        });
        video.addEventListener('loadeddata',function(){playVideo(video)});
        video.addEventListener('ended',function(){video.currentTime=0;playVideo(video)});
      });
      root.querySelector('[data-axm-prev]').addEventListener('click',function(){show(active-1)});
      root.querySelector('[data-axm-next]').addEventListener('click',function(){show(active+1)});
      dots.forEach(function(dot,i){dot.addEventListener('click',function(){show(i)})});
      cards.forEach(function(card,i){
        card.addEventListener('click',function(){if(Date.now()<skipClickUntil)return;if(i!==active)show(i);else playAll()});
        card.addEventListener('keydown',function(e){
          if(e.key==='Enter'||e.key===' '){e.preventDefault();show(i)}
        });
      });
      stage.addEventListener('touchstart',function(e){
        if(e.touches.length!==1||e.target.closest('button'))return;
        touching=true;
        downX=e.touches[0].clientX;
        downY=e.touches[0].clientY;
      },{passive:true});
      stage.addEventListener('touchend',function(e){
        if(!touching||e.changedTouches.length!==1){touching=false;return}
        touching=false;
        var dx=e.changedTouches[0].clientX-downX;
        var dy=e.changedTouches[0].clientY-downY;
        if(Math.abs(dx)>=42&&Math.abs(dx)>Math.abs(dy)*1.3){
          skipClickUntil=Date.now()+350;
          show(active+(dx<0?1:-1));
        }
      },{passive:true});
      stage.addEventListener('touchcancel',function(){touching=false},{passive:true});
      document.addEventListener('visibilitychange',function(){if(!document.hidden)playAll()});
      window.addEventListener('pageshow',playAll);
      show(0);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();